import { combineReducers } from "redux";
import { enroll } from "./enroll";

const reducers = combineReducers({
    enroll,
});

export default reducers;